<template>
  <v-btn outline
         large
         color="secondary"
         v-bind="$attrs"
         v-on="$listeners"
         :loading="loading"
        :class="loading?'lock':''"
        @click="loader = 'loading'">
    <slot></slot>
  </v-btn>
</template>
<script>
import BaseBtn from './BaseBtn'
export default {
  name: 'btn-lg-secondary',
  extends: BaseBtn
}
</script>
<style lang="stylus" scoped></style>
